import { createContext } from 'react';
import type { AuthSession, AuthUser } from '../lib/auth-client';

export type AuthContextValue = {
  loading: boolean;
  session: AuthSession | null;
  user: AuthUser | null;
  signOut: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
